module.exports = __webpack_public_path__ + "img/defaultprofilepic.eab26f29.jpg";